import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import logo from '../assets/Urbanwebhost-Logo_w.svg';

const Navigation = () => {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);

  const lessons = [
    { num: 1, title: "Components & JSX", path: "/lesson1" },
    { num: 2, title: "Props", path: "/lesson2" },
    { num: 3, title: "State (useState)", path: "/lesson3" },
    { num: 4, title: "useEffect Hook", path: "/lesson4" },
    { num: 5, title: "Conditional Rendering", path: "/lesson5" },
    { num: 6, title: "Lists & Keys", path: "/lesson6" },
    { num: 7, title: "Forms", path: "/lesson7" },
    { num: 8, title: "Event Handling", path: "/lesson8" },
    { num: 9, title: "Context API", path: "/lesson9" },
    { num: 10, title: "Redux vs Context", path: "/lesson10" },
    { num: 11, title: "useReducer Hook", path: "/lesson11" },
    { num: 12, title: "Custom Hooks", path: "/lesson12" },
    { num: 13, title: "useRef Hook", path: "/lesson13" },
    { num: 14, title: "useMemo Hook", path: "/lesson14" },
    { num: 15, title: "useCallback Hook", path: "/lesson15" },
    { num: 16, title: "Component Lifecycle", path: "/lesson16" },
    { num: 17, title: "API Integration", path: "/lesson17" },
    { num: 18, title: "Error Boundaries", path: "/lesson18" },
    { num: 19, title: "Lazy Loading", path: "/lesson19" },
    { num: 20, title: "Bootstrap in React", path: "/lesson20" },
  ];

  const handleNavClick = (lessonTitle) => {
    console.log(`🔗 Navigation: Clicked on ${lessonTitle}`);
    setExpanded(false);
  };

  return (
    <Navbar bg="dark" variant="dark" expand="lg" sticky="top" expanded={expanded}>
      <Container>
        <Navbar.Brand as={Link} to="/" onClick={() => handleNavClick('Home')}>
          <img
            src={logo}
            alt="Urban Web .Host"
            className="d-inline-block align-top me-2 navbar-brand-logo"
          />
          <span className="brand-text">React Easy Learning</span>
        </Navbar.Brand>
        <Navbar.Toggle 
          aria-controls="basic-navbar-nav" 
          onClick={() => setExpanded(!expanded)}
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link 
              as={Link} 
              to="/" 
              active={location.pathname === '/'}
              onClick={() => handleNavClick('Home')}
            >
              Home
            </Nav.Link>

            {/* Fundamentals */}
            <NavDropdown title="Fundamentals (1-5)" id="fundamentals-dropdown">
              {lessons.slice(0, 5).map((lesson) => (
                <NavDropdown.Item
                  key={lesson.num}
                  as={Link}
                  to={lesson.path}
                  active={location.pathname === lesson.path}
                  onClick={() => handleNavClick(`Lesson ${lesson.num}: ${lesson.title}`)}
                >
                  {lesson.num}. {lesson.title}
                </NavDropdown.Item>
              ))}
            </NavDropdown>

            {/* Intermediate */}
            <NavDropdown title="Intermediate (6-10)" id="intermediate-dropdown">
              {lessons.slice(5, 10).map((lesson) => (
                <NavDropdown.Item
                  key={lesson.num}
                  as={Link}
                  to={lesson.path}
                  active={location.pathname === lesson.path}
                  onClick={() => handleNavClick(`Lesson ${lesson.num}: ${lesson.title}`)}
                >
                  {lesson.num}. {lesson.title}
                </NavDropdown.Item>
              ))}
            </NavDropdown>

            {/* Advanced */}
            <NavDropdown title="Advanced (11-15)" id="advanced-dropdown">
              {lessons.slice(10, 15).map((lesson) => (
                <NavDropdown.Item
                  key={lesson.num}
                  as={Link}
                  to={lesson.path}
                  active={location.pathname === lesson.path}
                  onClick={() => handleNavClick(`Lesson ${lesson.num}: ${lesson.title}`)}
                >
                  {lesson.num}. {lesson.title}
                </NavDropdown.Item>
              ))}
            </NavDropdown>

            {/* Expert */}
            <NavDropdown title="Expert (16-20)" id="expert-dropdown">
              {lessons.slice(15, 20).map((lesson) => (
                <NavDropdown.Item
                  key={lesson.num}
                  as={Link}
                  to={lesson.path}
                  active={location.pathname === lesson.path}
                  onClick={() => handleNavClick(`Lesson ${lesson.num}: ${lesson.title}`)}
                >
                  {lesson.num}. {lesson.title}
                </NavDropdown.Item>
              ))}
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
